<template>
  <v-container v-if="person" fluid>
    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          <span class="font-weight-medium">{{ fullName }}</span>
        </v-toolbar-title>

        <v-spacer />

        <v-spacer />
        <div v-if="person.user">
          <span class="text-caption mr-1">{{ $t('PERSONS.CATEGORIES') }}:</span>
          <template v-for="role in person.user.roles">
            <v-chip
              v-if="person.user.roles"
              :key="role.id"
              small
              color="primary"
              class="ml-1"
              >{{ role.title }}
            </v-chip>
          </template>
        </div>
      </v-toolbar>
    </v-card>

    <v-row class="mt-4">
      <v-col cols="12" md="8" sm="12">
        <main-information v-model="person" @update="update" />
        <user-information v-model="person" @update="update" />
      </v-col>

      <v-col cols="12" md="4" sm="12">
        <notes
          :person-requests="person.person_requests || []"
          :person-id="person.id"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <apartment v-model="person" @update="update" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <person-orders-list v-if="person" v-model="person" />
      </v-col>
    </v-row>
    <v-row>
      <v-col>
        <person-subscriptions-list v-if="person" :person-id="person.id" />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <person-invoices-list
          v-if="person"
          :person-id="person.id"
          :building-complex="buildingComplex"
        />
      </v-col>
    </v-row>

    <tabs v-if="person" :person="person" class="mt-3" />
  </v-container>
</template>

<script>
import { mapActions } from 'vuex';
import UserInformation from '@/modules/persons/components/UserInformation';
import { get } from 'lodash';

export default {
  name: 'PersonEditPage',

  components: {
    UserInformation,
    MainInformation: () =>
      import('@/modules/persons/components/MainInformation'),
    Apartment: () => import('@/modules/persons/components/Apartment'),
    Tabs: () => import('@/modules/persons/components/Tabs/Tabs'),
    Notes: () => import('@/modules/persons/components/Notes'),
    PersonOrdersList: () =>
      import('@/modules/persons/components/PersonOrdersList'),
    PersonSubscriptionsList: () =>
      import(
        '@/modules/persons/components/Subscriptions/PersonSubscriptionsList'
      ),
    PersonInvoicesList: () =>
      import('@/modules/persons/components/Invoices/PersonInvoicesList')
  },

  props: {
    id: {
      type: Number,
      required: true
    }
  },

  data: () => ({
    person: null
  }),

  computed: {
    fullName() {
      return `${this.person.first_name} ${this.person.last_name}`;
    },
    buildingComplex() {
      return get(
        this.person,
        'inhabitant.apartment.building.building_complex',
        {}
      );
    }
  },

  created() {
    this.setData();
  },

  methods: {
    ...mapActions('person', ['retrievePerson']),
    update() {
      this.setData();
    },
    setData() {
      this.retrievePerson(this.id).then(({ data }) => {
        this.person = data;
      });
    }
  }
};
</script>
